import React, { useEffect, useState } from 'react'
import { Table, Loader, Modal } from 'rsuite'

import DeleteUserModal from '../Components/AdminPanel/DeleteUser/DeleteUserModal'
import SendResetPasswordEmailModal
  from '../Components/AdminPanel/SendResetPasswordEmail/SendResetPasswordEmailModal'
import { useAuth } from '../Context/Auth'
import styles from '../Components/AdminPanel/styles'

const { Column, HeaderCell, Cell } = Table

const fetchAllUsersData = async token => {
  const url = 'https://us-central1-taito-training.cloudfunctions.net/getAllUsersData'
  const httpHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: token
  }
  try {
    const response = await fetch(url, {
      headers: httpHeaders
    })
    const users = await response.json()
    return users
  } catch (err) {
    console.error(err)
  }
}

const AdminPanel = () => {
  const { currentUser, resetPassword } = useAuth()
  const [allUsersData, setAllUsersData] = useState()
  const [currentUsersToken, setCurrentUsersToken] = useState()
  const [loading, setLoading] = useState(true)
  const [isDeleteUserModalVisible, setDeleteUserModalVisible] = useState(false)
  const [isResetPasswordModalVisible, setResetPasswordModalVisible] = useState(false)

  useEffect(() => {
    getAllUsersData()
  }, [])

  const getAllUsersData = async () => {
    try {
      const token = await currentUser.getIdToken(true)
      const usersData = await fetchAllUsersData(token)
      setCurrentUsersToken(token)
      setAllUsersData(usersData.users)
      setLoading(false)
    } catch (err) {
      console.log({ error: err })
    }
  }

  // console.log(allUsersData)

  return (
    <>
      {loading
        ? <Loader backdrop size='lg' content='loading...' vertical />
        : <>
          <Modal
            style={styles.modal}
            show={isDeleteUserModalVisible.showModal}
            onHide={() => setDeleteUserModalVisible(false)}
          >
            <DeleteUserModal
              userData={isDeleteUserModalVisible}
              setModalVisible={setDeleteUserModalVisible}
              token={currentUsersToken}
              updateUsersTable={getAllUsersData}
              setLoading={setLoading}
            />
          </Modal>

          <Modal
            style={styles.modal}
            show={isResetPasswordModalVisible.showModal}
            onHide={() => setResetPasswordModalVisible(false)}
          >
            <SendResetPasswordEmailModal
              userData={isResetPasswordModalVisible}
              setModalVisible={setResetPasswordModalVisible}
              resetPassword={resetPassword}
            />
          </Modal>

          <div style={styles.container}>
            {allUsersData &&
              <Table
                height={600}
                // autoHeight
                wordWrap
                bordered
                data={allUsersData}
                onRowClick={data => {
                  console.log(data)
                }}
              >
                <Column flexGrow>
                  <HeaderCell>User id</HeaderCell>
                  <Cell dataKey='uid' />
                </Column>

                <Column flexGrow>
                  <HeaderCell>Name</HeaderCell>
                  <Cell dataKey='displayName' />
                </Column>

                <Column flexGrow>
                  <HeaderCell>Email</HeaderCell>
                  <Cell dataKey='email' />
                </Column>

                <Column flexGrow>
                  <HeaderCell>Verified</HeaderCell>
                  <Cell>
                    {rowData => rowData.emailVerified.toString()}
                  </Cell>
                </Column>

                <Column flexGrow>
                  <HeaderCell>Last sign in</HeaderCell>
                  <Cell>
                    {rowData => rowData.metadata.lastSignInTime}
                  </Cell>
                </Column>

                <Column minWidth={270} flexGrow fixed='right'>
                  <HeaderCell>Action</HeaderCell>
                  <Cell>
                    {rowData => {
                      const removeUserHandler = () => {
                        setDeleteUserModalVisible({ ...rowData, showModal: true })
                      }
                      const sendPasswordChangeEmail = () => {
                        setResetPasswordModalVisible({ ...rowData, showModal: true })
                      }
                      return (
                        <span>
                          <a onClick={sendPasswordChangeEmail}>
                            Send reset password mail
                          </a> |{' '}
                          <a
                            onClick={removeUserHandler}
                            style={styles.removeUserButton}
                          >
                            Remove
                          </a>
                        </span>
                      )
                    }}
                  </Cell>
                </Column>
              </Table>}
          </div>
        </>}

    </>
  )
}

export default AdminPanel
